import { render, staticRenderFns } from "./public-number.vue?vue&type=template&id=23f6f67b&scoped=true&"
import script from "./public-number.vue?vue&type=script&lang=js&"
export * from "./public-number.vue?vue&type=script&lang=js&"
import style0 from "./public-number.vue?vue&type=style&index=0&id=23f6f67b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6f67b",
  null
  
)

export default component.exports